import { Button, Grid, Radio } from "@material-ui/core";
import { RefreshTwoTone, Search } from "@material-ui/icons";
import BlockIcon from "@material-ui/icons/Block";
import SaveIcon from "@material-ui/icons/Save";
import PopupForm from "app/common/Component/Popup/PopupForm";
import GlobitsTextField from "app/common/form/GlobitsTextField";
import { FLASH_SALE } from "app/common/LocalConst";
import { formatMoney } from "app/common/LocalFunction";
import { useStore } from "app/stores";
import { Form, Formik } from "formik";
import { observer } from "mobx-react";
import { useEffect } from "react";
import { checkValidFlashSale } from "utils";

const PromotionFreePopup = ({
  open,
  handleClose,
  initialValues,
  handleSubmit,
  promotionPrograms,
  handleChangeFormSearchPromotionProgram,
}) => {
  // nếu có crmUuid thì truyền { clientId: crmUuid }
  // nếu không có thì truyền { clientEmrMappingId: patientId }

  useEffect(() => {
    if (!initialValues?.patient?.id) return;

    const listBranchCode = initialValues?.department
      ? [initialValues.department.code]
      : [];

    const commonPayload = {
      drugs: initialValues?.drugs || [],
      paServiceRegister: initialValues?.paServiceRegister || [],
      listBranchCode,
      isPaying: false
    };

    if (initialValues?.patient?.crmUuid) {
      handleChangeFormSearchPromotionProgram({
        ...commonPayload,
        clientId: initialValues.patient.crmUuid
      });
    } else {
      handleChangeFormSearchPromotionProgram({
        ...commonPayload,
        clientEmrMappingId: initialValues.patient.id
      });
    }
  }, [initialValues?.patient?.id]);


  return (
    <PopupForm
      open={open}
      handleClose={handleClose}
      title="Chọn chương trình khuyến mãi"
      size="sm"
      formik={{
        initialValues: initialValues,
      }}
      action={({ values }) => (
        <>
          <Button
            startIcon={<BlockIcon />}
            onClick={handleClose}
            className="btn btn-gray d-inline-flex"
          >
            Đóng
          </Button>
          <Button
            startIcon={<SaveIcon />}
            className="btn btn-primary d-inline-flex"
            onClick={() => handleSubmit(values)}
          >
            Áp dụng
          </Button>
        </>
      )}
    >
      {({ setFieldValue, values }) => {
        return (
          <>
            <div style={{ padding: 8 }}>
              <SearchVoucher />
              <div style={{ maxHeight: 400, overflowY: "auto" }}>
                {promotionPrograms?.length > 0 ? (
                  promotionPrograms?.map((voucher) => {
                    const startDate = new Date(voucher?.startDate);
                    const endDate = new Date(voucher?.endDate);
                    const expiredDate = `Từ ${startDate.toLocaleDateString()} đến ${endDate.toLocaleDateString()}`;

                    // logic disabled : tiền hóa đơn >= tiền tối thiếu của voucher minInvoiceAmount;

                    const isDisabled =
                      voucher?.minInvoiceAmount != null &&
                      +values?.totalAmount < (voucher?.minInvoiceAmount || 0);

                    const isFlashSaleDisabled =
                      voucher?.promotionType === FLASH_SALE &&
                      !checkValidFlashSale(voucher?.flashSaleTimes);
                    return (
                      <div
                        key={voucher?.id}
                        onClick={() =>
                          setFieldValue("selectedVoucher", voucher)
                        }
                        className={`voucher-item ${values?.selectedVoucher?.id === voucher?.id
                          ? "selected"
                          : ""
                          } ${(isDisabled || isFlashSaleDisabled) && "disabled"
                          } `}
                      >
                        <div
                          style={{
                            width: 80,
                            height: 80,
                            background: "#f8f9fa",
                            borderRadius: 8,
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            flexShrink: 0,
                          }}
                        >
                          <span
                            style={{
                              fontSize: 12,
                              color: "#d32f2f",
                              fontWeight: "bold",
                            }}
                          >
                            CTKM
                          </span>
                        </div>
                        <div style={{ flex: 1, paddingLeft: 12 }}>
                          <div style={{ fontWeight: "bold" }}>
                            {voucher.name || "Không có tên chương trình"}
                          </div>
                          <div
                            style={{
                              fontSize: 12,
                              color: "#999",
                            }}
                          >
                            Thời gian: {expiredDate}
                          </div>
                          {voucher?.description && (
                            <div
                              style={{
                                fontSize: 12,
                                color: "#999",
                              }}
                            >
                              Ghi chú: {voucher?.description || ""}
                            </div>
                          )}

                          {voucher?.minInvoiceAmount != null &&
                            +values?.totalAmount <
                            (voucher?.minInvoiceAmount || 0) && (
                              <div
                                style={{
                                  fontSize: 13,
                                  color: "red",
                                }}
                              >
                                Đơn còn thiếu :{" "}
                                {formatMoney(
                                  voucher?.minInvoiceAmount -
                                  (values?.totalAmount || 0)
                                )}{" "}
                                đ
                              </div>
                            )}
                        </div>

                        <Radio
                          checked={values?.selectedVoucher?.id === voucher?.id}
                          color="primary"
                          disabled={isDisabled || isFlashSaleDisabled}
                          style={{ marginLeft: 8 }}
                          name="promotionProgram"
                          onChange={(e) => {
                            e.stopPropagation();
                            setFieldValue("selectedVoucher", voucher);
                          }}
                        />
                      </div>
                    );
                  })
                ) : (
                  <div
                    style={{
                      textAlign: "center",
                      color: "#999",
                      padding: 20,
                    }}
                  >
                    Không có chương trình khuyến mãi nào.
                  </div>
                )}
              </div>
            </div>
          </>
        );
      }}
    </PopupForm>
  );
};

const SearchVoucher = observer(() => {
  const {
    searchPromotionProgramVoucher,
    handleChangeFormSearchPromotionProgram,
  } = useStore().feeStore.serviceFeeTabStore;
  return (
    <>
      <Formik
        initialValues={searchPromotionProgramVoucher}
        onSubmit={handleChangeFormSearchPromotionProgram}
        enableReinitialize
      >
        {({ setFieldValue, values }) => {
          return (
            <>
              <Form autoComplete="off">
                <Grid
                  container
                  component={"section"}
                  spacing={1}
                  className="mb-2"
                >
                  <Grid item xs={8} md={6}>
                    <GlobitsTextField
                      name={"promotionCode"}
                      label={"Mã voucher"}
                      placeholder={"Nhập mã voucher"}
                    />
                  </Grid>

                  <Grid item xs={4} md={"auto"} className="flex flex-end gap-2">
                    <Button className="btn-primary" type="submit">
                      <Search />
                      Tìm kiếm
                    </Button>
                    <Button
                      className="btn-primary"
                      type="button"
                      onClick={() => setFieldValue("promotionCode", null)}
                    >
                      <RefreshTwoTone />
                      Làm mới
                    </Button>
                  </Grid>
                </Grid>
              </Form>
            </>
          );
        }}
      </Formik>
    </>
  );
});

export default observer(PromotionFreePopup);
